import {
  GET_MALWARE_SCAN_LOGS,
  GET_MALWARE_SCAN_LOGS_SUCCESSFUL,
  GET_MALWARE_SCAN_LOGS_FAILED,
  CLEAR_ALL_MALWARE_SCAN_LOGS_MESSAGES,
  CLEAR_ALL_MALWARE_SCAN_LOGS_SUCCESSFUL,
} from "./actionTypes";

export const getMalwareScanLogs = () => ({
  type: GET_MALWARE_SCAN_LOGS,
  payload: {}
});

export const getMalwareScanLogsSuccessful = (malwareLogs) => ({
  type: GET_MALWARE_SCAN_LOGS_SUCCESSFUL,
  payload: { malwareLogs }
});

export const getMalwareScanLogsFailed = (getMalwareScanLogsError) => ({
  type: GET_MALWARE_SCAN_LOGS_FAILED,
  payload: { getMalwareScanLogsError }
});

export const clearAllMalwareScanLogsMessages = () => ({
  type: CLEAR_ALL_MALWARE_SCAN_LOGS_MESSAGES,
  payload: {}
});

export const clearAllMalwareScanLogsMessagesSuccessful = () => ({
  type: CLEAR_ALL_MALWARE_SCAN_LOGS_SUCCESSFUL,
  payload: {}
});
